module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {

 if(showPrice) { ;
__p += '\n    <div class="price ' +
((__t = ( priceCssClass )) == null ? '' : __t) +
'">\n        ';
 if(showSalesPrice) { ;
__p += '\n            <span class="sales_price">\n                ' +
((__t = ( new Intl.NumberFormat(I18n.locale, { style: 'currency', currency: currency || 'USD' }).format(parseFloat(decode_utf8(sales_price))) )) == null ? '' : __t) +
'\n            </span>\n        ';
 } ;
__p += '\n\n        <span class="cta_product_price">\n            ';
 if(showSalesPrice && wasOldPriceLayout) { ;
__p += '\n                ' +
((__t = ( I18n.t('lightbox.cta.was_old_price', {sales_price: new Intl.NumberFormat(I18n.locale, { style: 'currency', currency: currency || 'USD' }).format(parseFloat(decode_utf8(price)))}) )) == null ? '' : __t) +
'\n            ';
 } else { ;
__p += '\n                ' +
((__t = ( new Intl.NumberFormat(I18n.locale, { style: 'currency', currency: currency || 'USD' }).format(parseFloat(decode_utf8(price))) )) == null ? '' : __t) +
'\n            ';
 } ;
__p += '\n        </span>\n\n        ';
 if(showDiscountPercentage) { ;
__p += '\n        <span class="discount_percentage">' +
((__t = ( I18n.t('lightbox.cta.percent_off', { percent: discount_percentage }) )) == null ? '' : __t) +
'</span>\n        ';
 } ;
__p += '\n\n        ';
 if(showLowStock && !!stockLabelLayout && stockLabelLayout !== "badge_above") { ;
__p += '\n            <span class="product_stock\n            ' +
((__t = ( addClassIfTrue(stockLabelLayout === 'badge_beside', 'badge') )) == null ? '' : __t) +
'\n            ' +
((__t = ( addClassIfTrue(stockLabelLayout === 'below', 'below') )) == null ? '' : __t) +
'">\n                ' +
((__t = ( I18n.t('lightbox.cta.low_stock', { stock: stock }) )) == null ? '' : __t) +
'\n            </span>\n        ';
 } ;
__p += '\n\n    </div>\n';
 } ;
__p += '\n';

}
return __p
}